if (typeof window.initProductNanoGallery !== 'function') {
  window.initProductNanoGallery = function (root = document) {
    if (!window.jQuery || typeof window.jQuery.fn.nanogallery2 !== 'function') return;

    const scope = root instanceof Element ? root : document;

    scope
      .querySelectorAll('[data-nanogallery2]:not([data-nanogallery-init])')
      .forEach((gallery) => {
        window.jQuery(gallery).nanogallery2(window.jQuery(gallery).data('nanogallery2'));
        gallery.setAttribute('data-nanogallery-init', 'true');
      });

    scope
      .querySelectorAll('[data-nanogallery2-lightbox]:not([data-nanogallery-lightbox-init])')
      .forEach((lightbox) => {
        const handleClick = (event) => {
          event.preventDefault();

          const defaults = { lightboxStandalone: true, viewerToolbar: { display: false } };
          let options = window.jQuery.extend(true, {}, defaults);
          const groupName = lightbox.dataset.nanogallery2Lgroup;

          if (groupName) {
            const candidates = document.querySelectorAll('[data-nanogallery2-lightbox]');
            for (let index = 0; index < candidates.length; index += 1) {
              const candidate = candidates[index];
              if (
                candidate.dataset.nanogallery2Lgroup === groupName &&
                candidate.dataset.nanogallery2Lightbox
              ) {
                options = window.jQuery.extend(
                  true,
                  {},
                  defaults,
                  window.jQuery(candidate).data('nanogallery2Lightbox')
                );
                break;
              }
            }
          }

          const elementOptions = window.jQuery(lightbox).data('nanogallery2Lightbox');
          if (elementOptions) {
            options = window.jQuery.extend(true, options, elementOptions);
          }

          window.jQuery(lightbox).nanogallery2(options);
        };

        lightbox.classList.add('NGY2ThumbnailLightbox');
        lightbox.addEventListener('click', handleClick);
        lightbox.setAttribute('data-nanogallery-lightbox-init', 'true');
      });
  };
}

if (typeof window.initProductAccordions !== 'function') {
  window.initProductAccordions = function (root = document) {
    const scope = root instanceof Element ? root : document;
    const headers = scope.querySelectorAll('[js-accordion-header]');
    if (!headers.length) return;

    headers.forEach((header) => {
      if (header.dataset.accordionBound === 'true') return;

      header.dataset.accordionBound = 'true';
      header.addEventListener('click', function () {
        const accordionItems = document.querySelectorAll('[js-accordion-item]');
        const accordionItem = this.parentElement;
        const accordionPanel = accordionItem.querySelector('[js-accordion-panel]');
        let height = 0;
        if (accordionPanel) {
          const panelInner = accordionPanel.querySelector('.panel__inner');
          height = panelInner ? panelInner.offsetHeight : 0;
          if (window.innerWidth <= 749) {
            height += 60;
          }
        }

        const isOpen = accordionItem.classList.contains('active');
        accordionItems.forEach((accordion) => {
          accordion.classList.remove('active');
        });

        if (!isOpen) {
          accordionItem.classList.add('active');
        }
      });
    });
  };
}

if (window.ProductStitchesSwitcher) {
  if (typeof window.initProductStitchesSelectors === 'function') {
    window.initProductStitchesSelectors();
  }
} else {
  class ProductStitchesSwitcher {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.sectionDomId = `MainProduct-${this.sectionId}`;
      this.inputName = `product-stitches-${this.sectionId}`;
      this.inputs = Array.from(container.querySelectorAll(`input[name="${this.inputName}"]`));
      this.isLoading = false;

      this.container.setAttribute('data-stitches-initialized', 'true');

      if (!this.inputs.length || !this.sectionId) return;

      this.handleInputChange = this.handleInputChange.bind(this);
      this.container.addEventListener('change', this.handleInputChange);
    }

    handleInputChange(event) {
      const input = event.target;
      if (input.tagName !== 'INPUT' || !this.inputs.includes(input)) return;

      const targetUrl = input.dataset.stitchUrl;
      if (!targetUrl || this.isLoading) return;

      const nextUrl = new URL(targetUrl, window.location.origin);
      const currentUrl = new URL(window.location.href);
      const normalizedTarget = `${nextUrl.pathname}${nextUrl.search}`;
      const normalizedCurrent = `${currentUrl.pathname}${currentUrl.search}`;

      if (normalizedTarget === normalizedCurrent) return;

      this.loadProduct(normalizedTarget);
    }

    loadProduct(url) {
      this.isLoading = true;
      this.setLoadingState(true);

      fetch(this.buildSectionRequest(url), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Section fetch failed');
          return response.text();
        })
        .then((html) => {
          this.replaceSection(html, url);
        })
        .catch(() => {
          window.location.href = url;
        })
        .finally(() => {
          this.isLoading = false;
          this.setLoadingState(false);
          let event = new Event('DOMContentLoaded', { bubbles: true, cancelable: false });
          document.dispatchEvent(event);
        });
    }

    buildSectionRequest(url) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}section_id=${this.sectionId}`;
    }

    replaceSection(html, targetUrl) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.getElementById(this.sectionDomId);
      const currentSection = document.getElementById(this.sectionDomId);

      if (!newSection || !currentSection) {
        window.location.href = targetUrl;
        return;
      }

      currentSection.replaceWith(newSection);
      this.dispatchSectionLoad(newSection);

      try {
        window.history.replaceState({}, '', targetUrl);
      } catch (error) {
        /* no-op */
      }

      if (typeof window.initProductStitchesSelectors === 'function') {
        window.initProductStitchesSelectors(newSection);
      }
      if (typeof window.initProductAccordions === 'function') {
        window.initProductAccordions(newSection);
      }
      if (typeof window.initProductNanoGallery === 'function') {
        window.initProductNanoGallery(newSection);
      }
    }

    dispatchSectionLoad(section) {
      if (!section) return;

      const event = new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: this.sectionId },
      });
      section.dispatchEvent(event);
    }

    setLoadingState(isLoading) {
      if (!this.container || !this.container.isConnected) return;

      this.container.classList.toggle('is-loading', isLoading);
      this.inputs.forEach((input) => {
        input.disabled = isLoading;
      });
    }
  }

  window.ProductStitchesSwitcher = ProductStitchesSwitcher;

  window.initProductStitchesSelectors = function (root = document) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope
      .querySelectorAll('[data-product-stitches]:not([data-stitches-initialized])')
      .forEach((container) => {
        new window.ProductStitchesSwitcher(container);
      });
  };

  const initializeStitches = () => window.initProductStitchesSelectors();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStitches);
  } else {
    initializeStitches();
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.initProductStitchesSelectors(event.target);
    if (typeof window.initProductNanoGallery === 'function') {
      window.initProductNanoGallery(event.target);
    }
    if (typeof window.initProductAccordions === 'function') {
      window.initProductAccordions(event.target);
    }
  });
}
